export const starterFertilizer = {
  products: [
    { id: 1, name: '10-34-0', nitrogen: 10, phosphorus: 34, potassium: 0, sulfur: 0, density: 11.72 },
    { id: 2, name: '32-0-0', nitrogen: 32, phosphorus: 0, potassium: 0, sulfur: 0, density: 11.04 },
    { id: 3, name: '12-0-0-26', nitrogen: 12, phosphorus: 0, potassium: 0, sulfur: 26, density: 11.1 },
    { id: 4, name: '6-24-6', nitrogen: 6, phosphorus: 24, potassium: 6, sulfur: 0, density: 11.25 },
    { id: 5, name: '9-18-9', nitrogen: 9, phosphorus: 18, potassium: 9, sulfur: 0, density: 11.2 },
    { id: 6, name: '0-0-25-17', nitrogen: 0, phosphorus: 0, potassium: 25, sulfur: 17, density: 12.2 },
    { id: 7, name: '28-0-0', nitrogen: 28, phosphorus: 0, potassium: 0, sulfur: 0, density: 10.67 },
    { id: 10001, nitrogen: 0, phosphorus: 0, potassium: 0, sulfur: 0, name: 'Other', custom: true },
    { id: 10002, nitrogen: 0, phosphorus: 0, potassium: 0, sulfur: 0, name: 'Other', custom: true },
    { id: 10003, nitrogen: 0, phosphorus: 0, potassium: 0, sulfur: 0, name: 'Other', custom: true },
  ],

  plannedYears: [new Date().getFullYear(), new Date().getFullYear() + 1],
};
